import moment from 'moment-timezone';
import {  useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PacmanLoader } from 'react-spinners';
import EventController from '../controllers/EventController';
import EventViewModel from '../models/events/GetEvents/EventViewModel';

export default function Events() {
    const [loading, setLoading] = useState(true);
    const [hasMultipleMembers, setHasMultipleMembers] = useState<boolean | null>(null);
    const [events, setEvents] = useState<EventViewModel[]>();
    const eventController = new EventController();
    
    useEffect(() => {
        if (events == null) {
            getEvents();
        }
    })

    const getEvents = async () => {
        var result = await eventController.GetEvents()
        if (result != null) {
            setEvents(result);
        }
        setLoading(false);
    }

    if (loading) {
        return <div className="col-6 mx-auto text-center"><PacmanLoader color="#947a27" /></div>
    }

    return (
        <div className="col-12 mx-auto">
            <h1 className="text-center">Events</h1>
            <br />
            <table className="table table-dark">
                <thead>
                    <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Hosts</th>
                        <th scope="col">Start Time</th>
                        <th scope="col">End Time</th>
                        <th scope="col">Number of Attendees</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    {events && events.map((event, index) => {
                        return  <tr key={index.toString()} >
                                    <td scope="row" style={{ textAlign: "left" }}>{event.Name}</td>
                                    <td style={{ textAlign: "left" }}>{event.Hosts}</td>
                                    <td style={{ textAlign: "left" }}>{moment.utc(event.StartTime).tz('Europe/London').format("ddd DD MMM yyyy HH:mm")}</td>
                                    <td style={{ textAlign: "left" }}>{moment.utc(event.EndTime).tz('Europe/London').format("ddd DD MMM yyyy HH:mm")}</td>
                                    <td style={{ textAlign: "left" }}>{event.NumberOfAttendees}</td>
                                    <td><Link className="btn btn-light" to={`/eventDetails/${event.Id}`}>Details</Link></td>
                                </tr>
                    })
                    }
                </tbody>
            </table>
        </div >
    );
}